<template>
  <div :id="id" class="scroll-container custom-scrollbar" v-bind:style="{'max-height' : maxHeight ? maxHeight : '25vh'}">
    <s-card  class="stretch-self" :padding="padding">
      <slot></slot>
    </s-card>
  </div>

</template>

<script>
import SCard from "./SCard";
import * as JSFunctions from "../Functions/Functions"
export default {
  name: "SScrollView",
  data(){
    return {
      id: JSFunctions.uuid()
    }
  },
  props: {
    padding: { type: Boolean, default: false},
    border: {type: Boolean, default: false},
    shadow: {type: Boolean, default: false},
    maxHeight: {required: false},
  },
  mounted() {
    this.$emit("id", this.id)
  },
  methods: {
    getClasses() {
      let cssClass = "";
      if (this.padding) {
        cssClass = cssClass + " card-padding";
      }
      if (this.border) {
        // console.log(this.border);
        cssClass = cssClass + " card-border";
      }
      return cssClass;
    },

    hide: function() {
      if(this.shadow){
        var cardElement = document.getElementById('card');
        cardElement.style.borderShadow = "none";
      }
    },

    onClickCard(){
      if(this.shadow){
        var cardElement = document.getElementById('card');
        cardElement.style.borderShadow = "0 0 50px var(--very-light-pink)";
      }
    }
  },
  components: {
   SCard
  },
  computed: {
  shadowStyle() {
    return{
        "-webkit-box-shadow": "0 0 50px var(--very-light-pink)",
        "box-shadow": "0 0 50px var(--very-light-pink)"
    }
  }
  }
};
</script>

<style  scoped>
.card {
  height: auto;
}
.card-padding {
  padding: 24px;
}
.card-border{
  border: solid 1px var(--very-light-pink);
}
.scroll-container {
  overflow-y: scroll;
  display: flex;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: stretch;
  padding-top: 16px;
  border-right: solid 1px var(--very-light-pink);
  border-top: solid 1px var(--very-light-pink);
  border-left: solid 1px var(--very-light-pink);
}

.stretch-self {
  flex-grow: 1;
}

/* custom scrollbar */
::-webkit-scrollbar {
  width: 23px;

}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d8d8d8;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #acacac;
}
</style>